import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-explain-faq',
  templateUrl: './explain-faq.component.html',
  styleUrls: ['./explain-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExplainFaqComponent {}
